// extracted by mini-css-extract-plugin
export default {"animation":"animation__Xaxfx","fadeInAnimation":"fadeInAnimation__NJQXO","heading":"heading__CrnVI","textArea":"textArea__hCy6u","submitButton":"submitButton__WK54E"};